import { Effect } from 'effect';

import { setCartItemQuantity } from '@vs-shop/engine/module/cart/cartOperations';
import type { CartMutationItem } from '../../bind/cartMutationItem';
import { TenantConfig } from '../../service/tenant/TenantConfig';
import {
  createAddToCartPayloadFromCartItem,
  createRemoveFromCartPayloadFromCartItem,
} from '../../utils/gtm/create/cart-items-update';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export type UpdateOrderItemQuantityData = {
  quantity: number;
  cartItem: CartMutationItem;
  previousQuantity: number;
};

export default function updateOrderItemQuantity(data: UpdateOrderItemQuantityData) {
  return Effect.gen(function* () {
    const { currency } = yield* TenantConfig;

    const cart = yield* setCartItemQuantity({
      itemId: data.cartItem.id,
      quantity: data.quantity,
    });

    // Send appropriate GTM event based on quantity change
    const quantityDelta = Math.abs(data.quantity - data.previousQuantity);
    const isDecrement = data.quantity < data.previousQuantity;

    if (isDecrement) {
      yield* createRemoveFromCartPayloadFromCartItem(
        data.cartItem.event,
        quantityDelta,
        currency
      ).pipe(Effect.flatMap((event) => sendGtmEvent(event, true)));
    } else {
      yield* createAddToCartPayloadFromCartItem(data.cartItem.event, quantityDelta, currency).pipe(
        Effect.flatMap((event) => sendGtmEvent(event, true))
      );
    }

    return cart;
  });
}
